module.exports = __webpack_public_path__ + "assets/HKNova-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Thin.woff2
// module id = 148
// module chunks = 0